import { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { openCart } from "../../redux";
import { LangContext } from '../../context/LangContext';
import useViewport from '../../hooks/useViewport';
import './style.css';

import icon_cart from '../../assets/svg/basket.svg'

function BtnCart({ anim }) {
    const dispatch = useDispatch();
    const { isDesktop } = useViewport();
    const { translations } = useContext(LangContext);
    const headerHeight = useSelector(state => state.options.headerHeight);

    return (
        <button
            className={"btn_cart " + anim}
            onClick={() => dispatch(openCart(true))}
            style={{ top: `calc(${headerHeight}px + ${isDesktop ? '34' : '19'}px)` }}
        >
            <p>{translations.cart}</p>
            <img src={icon_cart} alt="" />
        </button>
    );
}

export default BtnCart;